import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  da: {
    // Navigation
    "nav.home": "Forside",
    "nav.sell": "Sælg din Leasing bil",
    "nav.export": "Eksportbiler",
    "nav.history": "Vores historie",
    "nav.contact": "Kontakt os",
    "nav.cta": "SÆLG DIN LEASINGBIL",

    // Hero
    "hero.rating": "4,6/5 PÅ GOOGLE",
    "hero.title": "SÆLG DIN BIL TIL EN EXPORT EKSPERT — ENKELT, HURTIGT, KONKURRENCEDYGTIGT!",
    "hero.cta_valuation": "FÅ GRATIS VURDERING",
    "hero.cta_how": "HVORDAN FUNGERER DET?",

    // Afgiftsfri Banner
    "banner.title": "Vi køber udelukkende kun leasingbiler -uden afgift og -uden moms.",
    "banner.desc": "Har du en leasingbil, der skal afvikles uden registreringsafgift og moms? Få en specialiseret og lynhurtig markedsvurdering med henblik på direkte eksport.",
    "banner.cta": "BEREGN VÆRDI UDEN AFGIFT",

    // Showcase Gallery
    "gallery.title": "KLARGØRING, SYN OG OVERDRAGELSER",

    // How It Works
    "how.title": "Sådan fungerer det i praksis",
    "how.desc": "Vi har fjernet alt det besværlige ved bilsalg. Hele processen er strømlinet, tryg og gennemskuelig.",
    "how.step1_title": "Indsend oplysninger",
    "how.step1_desc": "Udfyld vores intelligente formular på under 2 minutter med bilens detaljer og billeder.",
    "how.step2_title": "Vi vurderer bilen",
    "how.step2_desc": "Vores eksperter analyserer markedet og giver dig et konkret, uforpligtende tilbud indenfor 24 timer.",
    "how.step3_title": "Vi klarer papirarbejdet",
    "how.step3_desc": "Vi klarer alt det administrative papirarbejde og sørger for en sikker og hurtig afvikling.",
    "how.step4_title": "Hurtig afhentning",
    "how.step4_desc": "Vi afhenter bilen på din adresse eller arbejdsplads i hele Danmark – kvit og frit.",

    // Benefits
    "benefits.title": "Vi er specialister i bilsalg og eksport",
    "benefits.desc": "De fleste klassiske bilforhandlere fokuserer blot på det danske marked. Vi fokuserer på at løse dit specifikke problem: Hvordan sælger du din bil nemt, hurtigt og til den bedste pris via eksport?",
    "benefits.bullet1": "Særlig ekspertise i eksportmarkederne",
    "benefits.bullet2": "Næsten 20 års erfaring i bilbranchen",
    "benefits.bullet3": "Sikker betaling via bankoverførsel",
    "benefits.more": "Vis flere fordele",
    "benefits.less": "Vis færre fordele",
    "benefits.b1_title": "Hurtig vurdering",
    "benefits.b1_desc": "Du modtager et konkret og uforpligtende købstilbud indenfor 24 timer på hverdage.",
    "benefits.b2_title": "Ingen skjulte gebyrer",
    "benefits.b2_desc": "Det er 100% gratis at benytte vores tjeneste. Ingen administrationsgebyrer eller overraskelser.",
    "benefits.b3_title": "Landsdækkende afhentning",
    "benefits.b3_desc": "Uanset hvor i Danmark din bil befinder sig, afhenter vi den kvit og frit på din adresse.",
    "benefits.b4_title": "Ekspertise i eksport",
    "benefits.b4_desc": "Vi har særlig ekspertise i eksportmarkederne, hvilket sikrer dig den absolut bedste pris.",
    "benefits.b5_title": "Sikker betaling",
    "benefits.b5_desc": "Vi overfører pengene sikkert via bankoverførsel i fuld overensstemmelse med hvidvasklovgivningen.",
    "benefits.b6_title": "Personlig rådgivning",
    "benefits.b6_desc": "Vores eksperter rådgiver dig gennem hele forløbet, så du føler dig tryg hele vejen.",
    "benefits.b7_title": "Sikker overdragelse",
    "benefits.b7_desc": "Vi underskriver en juridisk bindende slutseddel digitalt med MitID, før bilen overdrages.",
    "benefits.b8_title": "Professionel klargøring",
    "benefits.b8_desc": "Vi overtager bilen som den er, og sørger for professionel klargøring og syn.",

    // Reviews Section
    "reviews.title": "Hvad vores kunder siger",
    "reviews.desc": "Vi lægger stor vægt på gennemsigtighed, tryghed og personlig service. Her er et udpluk af vores kunders erfaringer.",
    "reviews.prev": "Forrige",
    "reviews.next": "Næste",

    // Step Form
    "form.title": "Få en gratis og uforpligtende markedsvurdering",
    "form.desc": "Udfyld formularen nedenfor. Det tager under 2 minutter, og du får svar indenfor 24 timer.",
    "form.step": "Trin",
    "form.of": "af",
    "form.next": "Næste trin",
    "form.prev": "Forrige trin",
    "form.submit": "Indsend forespørgsel",
    "form.submitting": "Indsender...",
    "form.success_title": "Tak for din forespørgsel!",
    "form.success_desc": "Vi har modtaget dine oplysninger og vil nu vurdere din bil. Du vil modtage et uforpligtende tilbud indenfor 24 timer på hverdage.",
    "form.success_id": "Dit referencenummer er:",
    "form.error_title": "Der opstod en fejl",
    "form.error_desc": "Noget gik galt under indsendelsen. Prøv venligst igen eller kontakt os direkte.",
    "form.try_again": "Prøv igen",

    // Step Form Fields
    "form.step1_title": "Din bil",
    "form.step1_desc": "Indtast bilens grundlæggende oplysninger",
    "form.license_plate": "Nummerplade (valgfri)",
    "form.license_plate_placeholder": "F.eks. AB12345",
    "form.brand": "Mærke",
    "form.brand_placeholder": "F.eks. Audi, BMW, Tesla",
    "form.model": "Model & Variant",
    "form.model_placeholder": "F.eks. A4 Avant 2.0 TDI, i4 M50",

    "form.step2_title": "Leasing & Finansiering",
    "form.step2_desc": "Oplysninger om den nuværende aftale",
    "form.leasing_provider": "Leasingselskab / Udbyder",
    "form.leasing_provider_placeholder": "F.eks. ALD, LeasePlan, Jyske Finans",
    "form.residual_value": "Restværdi ex. afgift & moms (DKK)",
    "form.residual_value_placeholder": "F.eks. 150000",
    "form.expiry_date": "Udløbsdato for leasingaftale",

    "form.step3_title": "Bilens stand",
    "form.step3_desc": "Fortæl os om bilens nuværende stand",
    "form.mileage": "Kilometertal (km)",
    "form.mileage_placeholder": "F.eks. 85000",
    "form.damages": "Skader / Mangler",
    "form.damages_none": "Ingen skader (almindelige brugsspor)",
    "form.damages_minor": "Mindre skader (f.eks. stenslag, små ridser)",
    "form.damages_major": "Større skader (f.eks. buler, defekter)",
    "form.service_history": "Servicebog",
    "form.service_full": "Ja, fuld servicebog",
    "form.service_partial": "Delvist udfyldt",
    "form.service_none": "Nej, mangler service",

    "form.step4_title": "Upload billeder",
    "form.step4_desc": "Upload op til 5 billeder af bilen (f.eks. forside, bagside, kabine, restværdidokument)",
    "form.upload_drag": "Træk og slip dine billeder her, eller",
    "form.upload_browse": "gennemse filer",
    "form.upload_limits": "Max 5 filer. PDF, PNG, JPEG, GIF, WEBP. Max 10MB pr. fil (Max 20MB samlet).",
    "form.upload_count": "billeder valgt",

    "form.step5_title": "Kontakt",
    "form.step5_desc": "Hvor skal vi sende dit tilbud hen?",
    "form.name": "Fulde navn",
    "form.name_placeholder": "F.eks. Anders Andersen",
    "form.phone": "Telefonnummer",
    "form.phone_placeholder": "F.eks. 12345678",
    "form.email": "E-mailadresse",
    "form.email_placeholder": "F.eks. anders@mail.dk",

    // Footer
    "footer.desc": "Din professionelle partner inden for opkøb og eksport af leasingbiler. Vi sikrer dig en hurtig, sikker og gennemskuelig handel.",
    "footer.nav_title": "Navigation",
    "footer.contact_title": "Kontakt os",
    "footer.rights": "Alle rettigheder forbeholdes.",
    "footer.privacy": "Privatlivspolitik",
    "footer.terms": "Handelsbetingelser",

    // Contact Page
    "contact.title": "Kontakt os",
    "contact.desc": "Har du spørgsmål til bilsalg, eller ønsker du personlig rådgivning? Vores eksperter sidder klar til at hjælpe dig videre.",
    "contact.direct": "Direkte kontakt",
    "contact.email_desc": "Vi besvarer alle e-mails hurtigt i åbningstiden.",
    "contact.phone_desc": "Ring til os for en uforpligtende snak.",
    "contact.address_desc": "Besøg os efter forudgående aftale.",
    "contact.hours": "Åbningstider",
    "contact.hours_mon_thu": "Mandag - Torsdag",
    "contact.hours_fri": "Fredag",
    "contact.hours_weekdays": "Mandag - Fredag",
    "contact.hours_weekend": "Lørdag - Søndag",
    "contact.hours_weekend_val": "Efter aftale",
    "contact.hours_weekend_desc": "Lukket",
    "contact.badge_title": "Sikker og professionel afvikling",
    "contact.badge_desc": "Vi har næsten 20 års erfaring i bilbranchen og garanterer en fuldstændig gennemskuelig proces, hvor betaling sker sikkert via bankoverførsel.",
    "contact.form_title": "Send os en besked",
    "contact.form_desc": "Udfyld formularen nedenfor, så vender vi tilbage til dig hurtigst muligt.",
    "contact.form_success_title": "Tak for din besked!",
    "contact.form_success_desc": "Vi har modtaget din henvendelse og vender tilbage til dig hurtigst muligt – normalt indenfor 2 timer i vores åbningstid.",
    "contact.form_ref_id": "Reference-ID:",
    "contact.form_new_message": "Send en ny besked",
    "contact.form_name": "Navn *",
    "contact.form_name_placeholder": "Dit fulde navn",
    "contact.form_phone": "Telefonnummer",
    "contact.form_phone_placeholder": "F.eks. 12345678",
    "contact.form_email": "E-mailadresse *",
    "contact.form_email_placeholder": "din@email.dk",
    "contact.form_subject_label": "Hvad drejer det sig om?",
    "contact.form_subject": "Emne",
    "contact.form_subject_placeholder": "Vælg emne",
    "contact.form_subject_opt1": "Salg af leasingbil",
    "contact.form_subject_opt2": "Eksport af bil",
    "contact.form_subject_opt3": "Generel forespørgsel",
    "contact.form_subject_opt4": "Andet",
    "contact.form_subject_opt5": "Spørgsmål til en vurdering",
    "contact.form_message": "Besked *",
    "contact.form_message_placeholder": "Skriv din besked her...",
    "contact.form_upload_label": "Vedhæft dokumenter eller billeder (valgfrit)",
    "contact.form_upload_desc": "F.eks. registreringsattest eller billeder af bilen. Max 5 filer, maks 10 MB pr. fil (PDF, PNG, JPEG, GIF, WEBP).",
    "contact.form_upload_click": "Klik for at vælge filer",
    "contact.form_upload_drag": "eller træk dem herover",
    "contact.form_upload_selected": "Valgte filer",
    "contact.form_submitting": "Sender besked...",
    "contact.form_submit": "Send besked",
    "contact.form_success": "Tak for din besked! Vi vender tilbage til dig hurtigst muligt.",
    "contact.form_error": "Der opstod en fejl under indsendelsen. Prøv venligst igen.",

    // Export Cars Page
    "export.title": "Vejle Auto Export – Din troværdige partner til eksportbiler",
    "export.desc": "Vejle Auto Export er en velanset bilforhandler baseret i Danmark, der specialiserer sig i køb og salg af kvalitetsbiler til eksport. Med over 19 års erfaring har vi etableret os som en pålidelig kilde til brugte køretøjer i alle klasser.",
    "export.p2": "Vores udvalg er nøje udvalgt for at sikre, at kun biler af høj kvalitet tilbydes vores kunder. Vi er forpligtet til at yde en enestående service og ekspertrådgivning gennem alle faser af købsprocessen.",
    "export.p3": "Hvis du er ekspert i bilbranchen, inviterer vi dig til at kontakte os eller besøge vores lokation for at udforske vores udvalg og opdage, hvad der adskiller os. Vi er overbeviste om, at vores erfaring og engagement i topkvalitet vil overstige dine forventninger.",
    "export.cta_explore": "Udforsk vores udvalg af eksportbiler til salg i dag!",
    "export.cta_sale": "Eksportbiler til salg",
    "export.cta_mobile": "Besøg Mobile.de",
    "export.experience_badge": "19+ års erfaring",
    "export.experience_badge_desc": "Etableret som en pålidelig kilde til brugte køretøjer i alle klasser.",
    "export.sec2_title": "Anerkendt bilforhandler",
    "export.sec2_desc": "Vejle AutoExport er en anerkendt bilforhandler, der har betjent kunder i Danmark i over et årti. Vi specialiserer os i at levere brugte biler af høj kvalitet med avancerede teknologier fra modelår 2012 til 2022.",
    "export.sec2_p1": "Vores lager inkluderer et bredt udvalg af køretøjer i forskellige klasser, fra Aygo til McLaren, alle udstyret med avancerede køreteknologier.",
    "export.sec2_p2": "Vores forhandler tilbyder de nyeste funktioner, herunder avancerede førerassistentsystemer, selvparkering, adaptiv fartpilot, vognbaneassistent og meget mere.",
    "export.sec2_p3": "Vi giver vores kunder førsteklasses kundeservice for at hjælpe dem med at vælge den bil, der bedst passer til deres behov.",
    "export.sec2_p4": "Vi stræber efter at opretholde et bredt udvalg af biler på vores lager, hvorfor vi løbende opdaterer vores kollektion med de nyeste modeller. Vores mål er at tilbyde vores kunder mange muligheder, så de finder den bil, der passer perfekt til deres krav.",
    "export.sec3_title": "KONTAKT OS",
    "export.sec3_desc": "Har du spørgsmål, eller ønsker du et uforpligtende tilbud på din bil? Kontakt os i dag for en hurtig og professionel dialog.",
    "export.sec3_cta_contact": "Gå til kontaktformular",
    "export.sec3_cta_valuation": "Få gratis vurdering",

    "export.reviews_title": "Vores kunders anmeldelser",
    "export.reviews_desc": "Vi er stolte af vores høje kundetilfredshed på både Google og Mobile.de. Se vores vurderinger og anmeldelser direkte her.",
    "export.google_rating": "Fremragende på Google",
    "export.google_rating_desc": "Baseret på 69 anmeldelser",
    "export.google_cta": "Se anmeldelser på Google",
    "export.mobile_rating": "Fremragende på Mobile.de",
    "export.mobile_rating_desc": "Baseret på vores seneste vurderinger",
    "export.mobile_cta": "Se anmeldelser på Mobile.de",

    "export.terms_title": "B2B Eksportbetingelser & Salgsvilkår",
    "export.terms_subtitle": "Læs venligst vores officielle vilkår og betingelser for kommerciel B2B-eksport, betaling og dokumentation.",
    "export.terms_b2b_title": "B2B Eksportvilkår",
    "export.terms_b2b_text": "Sælges som et B2B-eksportkøretøj i nuværende stand uden garanti. Kun til eksport. Ingen reklamationer eller returret efter køb. Der tages forbehold for mellemsalg og fejl.",
    "export.terms_payment_title": "Betaling & Reservation",
    "export.terms_payment_b1": "Ingen ⛔ €500-sedler accepteres. Maksimal kontant betaling: €2.000.",
    "export.terms_payment_b2": "Reservation: Et depositum på 10% kræves inden for 2 arbejdsdage, med et minimum på €500. Bilen reserveres først, når depositummet er modtaget.",
    "export.terms_eu_title": "EU-erhvervsforhandlere",
    "export.terms_eu_subtitle": "Netto eller Brutto påkrævet:",
    "export.terms_eu_b1": "1. Erhvervsregister (momsregistreringsbevis)",
    "export.terms_eu_b2": "2. Momsnummer (VAT ID) og ejer/ID påkrævet",
    "export.terms_eu_b3": "✅ En VIES-kontrol vil blive udført før salget.",
    "export.terms_noneu_title": "Eksport uden for EU",
    "export.terms_noneu_b1": "25% momsdepositum + €53 MRN-toldgebyr påkrævet før frigivelse.",
    "export.terms_noneu_b2": "Momsen refunderes, når der fremvises gyldigt bevis for MRN Follow-up (Export & Transit) fra Europa-Kommissionen.",
    "export.terms_netto_title": "Dokumentation for nettobiler",
    "export.terms_netto_b1": "For moms faktura er salg i netto påkrævet.",
    "export.terms_netto_b2": "Ved EU-intern levering: Hvis intet CMR-dokument er tilgængeligt ved bilens ankomst, vil en købererklæring (DE-Gelangensbestätigung) blive udleveret som bevis for EU-levering.",
    "export.terms_brutto_title": "Dokumentation for bruttobiler",
    "export.terms_brutto_b1": "Video af læsning, der inkluderer adresse og stelnummer (VIN), eller underskrevet CMR er påkrævet.",
    "export.terms_plates_title": "Eksportplader & Forsikring",
    "export.terms_plates_b1": "Bestil 1 dag i forvejen.",
    "export.terms_plates_b2": "€30 pr. dag inkl. ansvarsforsikring, maksimalt 7 dage.",

    // Our History Page
    "history.title": "Hvem er Vejle Auto Export?",
    "history.desc": "Vi er en mellemstor til stor virksomhed med base i det sydlige Danmark, som specialiserer sig i opkøb af brugte biler i hele landet.",
    "history.p2": "Siden 2007 har Vejle AutoExport haft fokus på professionel handel med brugte køretøjer – både fra private og professionelle samarbejdspartnere.",
    "history.p3": "Vores forretning bygger på stor erfaring, effektivitet og pålidelighed gennem opkøb fra følgende segmenter:",
    "history.segment_b2b": "B2B (virksomhed til virksomhed)",
    "history.segment_b2c": "B2C (virksomhed til forbruger)",
    "history.segment_leasing": "Leasingselskaber",
    "history.segment_auctions": "Auktioner",
    "history.segment_banks": "Banker",
    "history.p4": "Vi tilbyder fleksible løsninger og en smidig handel, uanset om du repræsenterer en virksomhed, et leasingselskab, en bank eller er privatperson. Vores gode ry og brede netværk i branchen gør os til en foretrukken samarbejdspartner, når der skal handles brugte køretøjer.",
    "history.read_also": "LÆS OGSÅ OM",
    "history.read_sell": "Sælg din bil",
    "history.read_export": "Eksportbiler til salg",
    "history.sec2_title": "Hvad får jeg ud af at sælge min bil til Vejle Auto Export?",
    "history.val1_title": "Knowhow & Stort Netværk:",
    "history.val1_desc": "Vi har opbygget et stærkt netværk på over +3.000 udenlandske forhandlere, som sikrer den bedste pris for din bil.",
    "history.val2_title": "Hurtig og Nem Proces:",
    "history.val2_desc": "Sælg din bil uden besvær – vi står for det hele, så du stort set ikke skal røre en finger.",
    "history.val3_title": "100% Gennemskuelig Handel:",
    "history.val3_desc": "Hos os er hele processen gennemsigtig, så du trygt kan følge med fra start til slut.",
    "history.val4_title": "Mere end +19 års erfaring:",
    "history.val4_desc": "Vi har solid brancheerfaring og leverer professionel service, du kan stole på.",
    "history.sec3_title": "- KONTAKT OS -",
    "history.sec3_desc": "Har du spørgsmål, eller ønsker du et uforpligtende tilbud på din bil? Kontakt os i dag for en hurtig og professionel dialog.",
    "history.sec3_cta_form": "Gå til kontaktformular",
    "history.sec3_cta_val": "Få gratis vurdering",

    // Sell Leasing Car Page
    "sell.title": "Sælg din leasingbil uden afgift og moms",
    "sell.desc": "Har du en leasingbil, der skal afvikles? Vi er specialister i direkte opkøb og eksport af leasingbiler. Vi indfrier restværdien direkte hos dit leasingselskab og sikrer dig den absolut bedste markedspris.",
    "sell.cta_form": "Beregn din bils værdi nu",
    "sell.cta_how": "Se hvordan det fungerer",
    "sell.faq_title": "Ofte stillede spørgsmål om salg af leasingbil",
    "sell.faq_desc": "Her finder du svar på de mest almindelige spørgsmål om, hvordan vi hjælper dig med at afvikle din leasingbil hurtigt, sikkert og til den bedste pris.",
    "sell.reviews_title": "Hvad siger vores kunder om leasing-bilsalg?",
    "sell.reviews_desc": "Læs anmeldelser fra kunder, der har solgt deres leasingbil eller eksportbil gennem os.",
  },
  en: {
    // Navigation
    "nav.home": "Home",
    "nav.sell": "Sell leasing car",
    "nav.export": "Export cars",
    "nav.history": "Our history",
    "nav.contact": "Contact us",
    "nav.cta": "SELL YOUR LEASING CAR",

    // Hero
    "hero.rating": "4.6/5 ON GOOGLE",
    "hero.title": "SELL YOUR CAR TO AN EXPORT EXPERT — SIMPLE, FAST, COMPETITIVE!",
    "hero.cta_valuation": "GET FREE VALUATION",
    "hero.cta_how": "HOW DOES IT WORK?",

    // Afgiftsfri Banner
    "banner.title": "We exclusively buy leasing cars -without registration tax and -without VAT.",
    "banner.desc": "Do you have a leasing car that needs to be settled without registration tax and VAT? Get a specialized and lightning-fast market valuation for direct export.",
    "banner.cta": "CALCULATE VALUE WITHOUT TAX",

    // Showcase Gallery
    "gallery.title": "PREPARATION, INSPECTION AND HANDOVERS",

    // How It Works
    "how.title": "How it works in practice",
    "how.desc": "We have removed all the hassle of selling a car. The whole process is streamlined, safe, and transparent.",
    "how.step1_title": "Submit details",
    "how.step1_desc": "Fill out our intelligent form in under 2 minutes with the car's details and photos.",
    "how.step2_title": "We value the car",
    "how.step2_desc": "Our experts analyze the market and give you a concrete, non-binding offer within 24 hours.",
    "how.step3_title": "We handle paperwork",
    "how.step3_desc": "We handle all the administrative paperwork and ensure a safe and fast transaction.",
    "how.step4_title": "Fast pickup",
    "how.step4_desc": "We pick up the car at your address or workplace anywhere in Denmark – completely free of charge.",

    // Benefits
    "benefits.title": "We are specialists in car sales and export",
    "benefits.desc": "Most classic car dealers focus only on the Danish market. We focus on solving your specific problem: How do you sell your car easily, quickly, and at the best price via export?",
    "benefits.bullet1": "Special expertise in export markets",
    "benefits.bullet2": "Nearly 20 years of experience in the car industry",
    "benefits.bullet3": "Secure payment via bank transfer",
    "benefits.more": "Show more benefits",
    "benefits.less": "Show fewer benefits",
    "benefits.b1_title": "Fast valuation",
    "benefits.b1_desc": "You will receive a concrete and non-binding purchase offer within 24 hours on weekdays.",
    "benefits.b2_title": "No hidden fees",
    "benefits.b2_desc": "It is 100% free to use our service. No administration fees or surprises.",
    "benefits.b3_title": "Nationwide pickup",
    "benefits.b3_desc": "No matter where your car is in Denmark, we will pick it up free of charge at your address.",
    "benefits.b4_title": "Expertise in export",
    "benefits.b4_desc": "We have special expertise in the export markets, ensuring you get the absolute best price.",
    "benefits.b5_title": "Secure payment",
    "benefits.b5_desc": "We transfer the money securely via bank transfer in full compliance with anti-money laundering legislation.",
    "benefits.b6_title": "Personal advice",
    "benefits.b6_desc": "Our experts advise you throughout the process, so you feel safe all the way.",
    "benefits.b7_title": "Secure handover",
    "benefits.b7_desc": "We sign a legally binding sales contract digitally with MitID before the car is handed over.",
    "benefits.b8_title": "Professional preparation",
    "benefits.b8_desc": "We take over the car as it is, and take care of professional preparation and inspection.",

    // Reviews Section
    "reviews.title": "What our customers say",
    "reviews.desc": "We attach great importance to transparency, security, and personal service. Here is a selection of our customers' experiences.",
    "reviews.prev": "Previous",
    "reviews.next": "Next",

    // Step Form
    "form.title": "Get a free, non-binding market valuation",
    "form.desc": "Fill out the form below. It takes less than 2 minutes, and you will get a response within 24 hours.",
    "form.step": "Step",
    "form.of": "of",
    "form.next": "Next step",
    "form.prev": "Previous step",
    "form.submit": "Submit request",
    "form.submitting": "Submitting...",
    "form.success_title": "Thank you for your request!",
    "form.success_desc": "We have received your information and will now value your car. You will receive a non-binding offer within 24 hours on weekdays.",
    "form.success_id": "Your reference number is:",
    "form.error_title": "An error occurred",
    "form.error_desc": "Something went wrong during submission. Please try again or contact us directly.",
    "form.try_again": "Try again",

    // Step Form Fields
    "form.step1_title": "Your car",
    "form.step1_desc": "Enter the basic details of your car",
    "form.license_plate": "License plate (optional)",
    "form.license_plate_placeholder": "E.g. AB12345",
    "form.brand": "Brand",
    "form.brand_placeholder": "E.g. Audi, BMW, Tesla",
    "form.model": "Model & Variant",
    "form.model_placeholder": "E.g. A4 Avant 2.0 TDI, i4 M50",

    "form.step2_title": "Leasing & Financing",
    "form.step2_desc": "Information about the current agreement",
    "form.leasing_provider": "Leasing Company / Provider",
    "form.leasing_provider_placeholder": "E.g. ALD, LeasePlan, Jyske Finans",
    "form.residual_value": "Residual value ex. tax & VAT (DKK)",
    "form.residual_value_placeholder": "E.g. 150000",
    "form.expiry_date": "Leasing agreement expiry date",

    "form.step3_title": "Car condition",
    "form.step3_desc": "Tell us about the current condition of the car",
    "form.mileage": "Mileage (km)",
    "form.mileage_placeholder": "E.g. 85000",
    "form.damages": "Damages / Defects",
    "form.damages_none": "No damage (normal signs of wear)",
    "form.damages_minor": "Minor damage (e.g. stone chips, small scratches)",
    "form.damages_major": "Major damage (e.g. dents, defects)",
    "form.service_history": "Service history",
    "form.service_full": "Yes, full service history",
    "form.service_partial": "Partially completed",
    "form.service_none": "No, missing service",

    "form.step4_title": "Upload photos",
    "form.step4_desc": "Upload up to 5 photos of the car (e.g. front, back, interior, residual value document)",
    "form.upload_drag": "Drag and drop your photos here, or",
    "form.upload_browse": "browse files",
    "form.upload_limits": "Max 5 files. PDF, PNG, JPEG, GIF, WEBP. Max 10MB per file (Max 20MB total).",
    "form.upload_count": "photos selected",

    "form.step5_title": "Contact",
    "form.step5_desc": "Where should we send your offer?",
    "form.name": "Full name",
    "form.name_placeholder": "E.g. John Doe",
    "form.phone": "Phone number",
    "form.phone_placeholder": "E.g. 12345678",
    "form.email": "Email address",
    "form.email_placeholder": "E.g. john@mail.com",

    // Footer
    "footer.desc": "Your professional partner in the purchase and export of leasing cars. We ensure a fast, secure, and transparent transaction.",
    "footer.nav_title": "Navigation",
    "footer.contact_title": "Contact us",
    "footer.rights": "All rights reserved.",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms & Conditions",

    // Contact Page
    "contact.title": "Contact us",
    "contact.desc": "Do you have questions about selling your car, or do you want personal advice? Our experts are ready to help you.",
    "contact.direct": "Direct contact",
    "contact.email_desc": "We answer all emails quickly during business hours.",
    "contact.phone_desc": "Call us for a non-binding chat.",
    "contact.address_desc": "Visit us by prior appointment.",
    "contact.hours": "Opening hours",
    "contact.hours_mon_thu": "Monday - Thursday",
    "contact.hours_fri": "Friday",
    "contact.hours_weekdays": "Monday - Friday",
    "contact.hours_weekend": "Saturday - Sunday",
    "contact.hours_weekend_val": "By appointment",
    "contact.hours_weekend_desc": "Closed",
    "contact.badge_title": "Secure and professional transaction",
    "contact.badge_desc": "We have nearly 20 years of experience in the automotive industry and guarantee a completely transparent process, with payment securely made via bank transfer.",
    "contact.form_title": "Send us a message",
    "contact.form_desc": "Fill out the form below, and we will get back to you as soon as possible.",
    "contact.form_success_title": "Thank you for your message!",
    "contact.form_success_desc": "We have received your inquiry and will get back to you as soon as possible – usually within 2 hours during our business hours.",
    "contact.form_ref_id": "Reference ID:",
    "contact.form_new_message": "Send a new message",
    "contact.form_name": "Name *",
    "contact.form_name_placeholder": "Your full name",
    "contact.form_phone": "Phone number",
    "contact.form_phone_placeholder": "e.g. +45 12 34 56 78",
    "contact.form_email": "Email address *",
    "contact.form_email_placeholder": "your@email.com",
    "contact.form_subject_label": "What is it about?",
    "contact.form_subject": "Subject",
    "contact.form_subject_placeholder": "Select subject",
    "contact.form_subject_opt1": "Sale of leasing car",
    "contact.form_subject_opt2": "Export of car",
    "contact.form_subject_opt3": "General inquiry",
    "contact.form_subject_opt4": "Other",
    "contact.form_subject_opt5": "Questions about valuation",
    "contact.form_message": "Message *",
    "contact.form_message_placeholder": "Write your message here...",
    "contact.form_upload_label": "Attach documents or images (optional)",
    "contact.form_upload_desc": "e.g. registration certificate or pictures of the car. Max 5 files, max 10 MB per file (PDF, PNG, JPEG, GIF, WEBP).",
    "contact.form_upload_click": "Click to select files",
    "contact.form_upload_drag": "or drag them here",
    "contact.form_upload_selected": "Selected files",
    "contact.form_submitting": "Sending message...",
    "contact.form_submit": "Send message",
    "contact.form_success": "Thank you for your message! We will get back to you as soon as possible.",
    "contact.form_error": "An error occurred during submission. Please try again.",

    // Export Cars Page
    "export.title": "Vejle Auto Export – Your Trusted Partner for Export Cars",
    "export.desc": "Vejle Auto Export is a reputable auto dealer based in Denmark, specializing in the purchase and sale of quality cars for export. With over 19 years of experience, we have established ourselves as a trusted source for used vehicles across all classes.",
    "export.p2": "Our selection is carefully curated to ensure that only high-quality cars are offered to our clients. We are committed to providing outstanding service and expert advice throughout every stage of the purchasing process.",
    "export.p3": "If you are an automotive industry expert, we invite you to contact us or visit our location to explore our selection and discover what sets us apart. We are confident that our experience and commitment to excellence will exceed your expectations.",
    "export.cta_explore": "Explore our range of export cars for sale today!",
    "export.cta_sale": "Export Cars for sale",
    "export.cta_mobile": "Visit Mobile.de",
    "export.experience_badge": "19+ Years Experience",
    "export.experience_badge_desc": "Established as a trusted source for used vehicles across all classes.",
    "export.sec2_title": "Reputable Car Dealership",
    "export.sec2_desc": "Vejle AutoExport is a reputable car dealership that has been serving customers in Denmark for over a decade. We specialize in providing high-quality, pre-owned cars of various models ranging from 2012 to 2022.",
    "export.sec2_p1": "Our inventory includes a diverse range of vehicles across different classes, from Aygo to McLaren, all equipped with advanced driving technologies.",
    "export.sec2_p2": "Our dealership offers the latest driving capabilities, including advanced driver assistance systems, self-parking, adaptive cruise control, lane departure warning, and much more.",
    "export.sec2_p3": "We provide our customers with top-notch customer service to help them choose the car that best suits their needs.",
    "export.sec2_p4": "We strive to maintain a wide range of cars in our inventory, which is why we continuously update our collection with the latest models. Our goal is to offer our customers a wide range of options to choose from, ensuring that they find the car that perfectly fits their requirements.",
    "export.sec3_title": "CONTACT US",
    "export.sec3_desc": "Do you have questions, or do you want to get a non-binding offer for your car? Contact us today for a quick and professional dialogue.",
    "export.sec3_cta_contact": "Go to Contact Form",
    "export.sec3_cta_valuation": "Get Free Valuation",

    "export.reviews_title": "Our Customer Reviews",
    "export.reviews_desc": "We are proud of our high customer satisfaction on both Google and Mobile.de. View our ratings and reviews directly here.",
    "export.google_rating": "Excellent on Google",
    "export.google_rating_desc": "Based on 69 reviews",
    "export.google_cta": "View reviews on Google",
    "export.mobile_rating": "Excellent on Mobile.de",
    "export.mobile_rating_desc": "Based on our latest ratings",
    "export.mobile_cta": "View reviews on Mobile.de",

    "export.terms_title": "B2B Export Terms & Sales Conditions",
    "export.terms_subtitle": "Please read our official terms and conditions for commercial B2B exports, payments, and documentation.",
    "export.terms_b2b_title": "B2B Export Terms",
    "export.terms_b2b_text": "Sold as a B2B export vehicle in its current condition without warranty. For export only. No claims or returns after purchase. Subject to prior sale and errors.",
    "export.terms_payment_title": "Payment & Reservation",
    "export.terms_payment_b1": "No ⛔ €500 banknotes accepted. Maximum cash payment: €2,000.",
    "export.terms_payment_b2": "Reservation: A 10% deposit is required within 2 working days, with a minimum of €500. The car will only be held after the deposit is received.",
    "export.terms_eu_title": "EU Commercial Dealers",
    "export.terms_eu_subtitle": "Netto or Brutto Required:",
    "export.terms_eu_b1": "1. Commercial Register",
    "export.terms_eu_b2": "2. VAT ID and Owner/ID required",
    "export.terms_eu_b3": "✅ A VIES check will be performed before the sale.",
    "export.terms_noneu_title": "Non-EU Export",
    "export.terms_noneu_b1": "25% VAT deposit + €53 MRN customs fee required before release.",
    "export.terms_noneu_b2": "VAT is refunded once valid proof of MRN Follow-up (Export & Transit) from the European Commission is provided.",
    "export.terms_netto_title": "Netto Cars Documentation",
    "export.terms_netto_b1": "For the VAT invoice, the sale in netto is required.",
    "export.terms_netto_b2": "For EU intra-community supply: If no CMR document is available upon car arrival, a Customer Declaration (DE-Gelangensbestätigung) will be provided as proof of EU supply.",
    "export.terms_brutto_title": "Brutto Cars Documentation",
    "export.terms_brutto_b1": "Video of loading includes the address and VIN number, or the signed CMR required.",
    "export.terms_plates_title": "Export Plates & Insurance",
    "export.terms_plates_b1": "Order 1 day in advance.",
    "export.terms_plates_b2": "€30 per day incl. liability insurance, maximum 7 days.",

    // Our History Page
    "history.title": "Who is Vejle Auto Export?",
    "history.desc": "We are a medium to large company based in southern Denmark, specializing in the purchase of used cars nationwide.",
    "history.p2": "Since 2007, Vejle AutoExport has focused on professional trading of used vehicles – from both private and professional partners.",
    "history.p3": "Our business is built on extensive experience, efficiency, and reliability through acquisitions from the following segments:",
    "history.segment_b2b": "B2B (business to business)",
    "history.segment_b2c": "B2C (business to consumer)",
    "history.segment_leasing": "Leasing companies",
    "history.segment_auctions": "Auctions",
    "history.segment_banks": "Banks",
    "history.p4": "We offer flexible solutions and smooth transactions, whether you represent a company, a leasing company, a bank, or are a private individual. Our good reputation and wide network in the industry make us a preferred partner when trading used vehicles.",
    "history.read_also": "ALSO READ ABOUT",
    "history.read_sell": "Sell your car",
    "history.read_export": "Export Cars For Sale",
    "history.sec2_title": "What do I get out of selling my car to Vejle Auto Export?",
    "history.val1_title": "Know-how & Large Network:",
    "history.val1_desc": "We have built a strong network of over +3,000 foreign dealers, ensuring the best price for your car.",
    "history.val2_title": "Fast and Easy Process:",
    "history.val2_desc": "Sell your car without hassle – we handle everything so you hardly have to lift a finger.",
    "history.val3_title": "100% Transparent Deal:",
    "history.val3_desc": "With us, the entire process is transparent, so you can safely follow along from start to finish.",
    "history.val4_title": "More than +19 years of experience:",
    "history.val4_desc": "We have solid industry experience and deliver professional service you can trust.",
    "history.sec3_title": "- CONTACT US -",
    "history.sec3_desc": "Do you have questions, or do you want a non-binding offer for your car? Contact us today for a quick and professional dialogue.",
    "history.sec3_cta_form": "Go to Contact Form",
    "history.sec3_cta_val": "Get free valuation",

    // Sell Leasing Car Page
    "sell.title": "Sell your leasing car without tax and VAT",
    "sell.desc": "Do you have a leasing car that needs to be settled? We are specialists in direct purchase and export of leasing cars. We settle the residual value directly with your leasing company and ensure you get the absolute best market price.",
    "sell.cta_form": "Calculate your car's value now",
    "sell.cta_how": "See how it works",
    "sell.faq_title": "Frequently asked questions about selling a leasing car",
    "sell.faq_desc": "Here you will find answers to the most common questions about how we help you settle your leasing car quickly, safely, and at the best price.",
    "sell.reviews_title": "What our customers say about leasing car sales",
    "sell.reviews_desc": "Read reviews from customers who have sold their leasing or export car through us.",
  },
  de: {
    // Navigation
    "nav.home": "Startseite",
    "nav.sell": "Leasingauto verkaufen",
    "nav.export": "Exportfahrzeuge",
    "nav.history": "Unsere Geschichte",
    "nav.contact": "Kontakt",
    "nav.cta": "LEASINGAUTO VERKAUFEN",

    // Hero
    "hero.rating": "4,6/5 AUF GOOGLE",
    "hero.title": "VERKAUFEN SIE IHR AUTO AN EINEN EXPORT-EXPERTEN — EINFACH, SCHNELL, WETTBEWERBSFÄHIG!",
    "hero.cta_valuation": "KOSTENLOSE BEWERTUNG",
    "hero.cta_how": "WIE FUNKTIONIERT ES?",

    // Afgiftsfri Banner
    "banner.title": "Wir kaufen ausschließlich Leasingfahrzeuge -ohne Zulassungssteuer und -ohne MwSt.",
    "banner.desc": "Haben Sie ein Leasingfahrzeug, das ohne Zulassungssteuer und MwSt. abgewickelt werden soll? Erhalten Sie eine spezialisierte und blitzschnelle Marktbewertung für den direkten Export.",
    "banner.cta": "WERT OHNE STEUER BERECHNEN",

    // Showcase Gallery
    "gallery.title": "AUFBEREITUNG, INSPEKTION UND ÜBERGABEN",

    // How It Works
    "how.title": "So funktioniert es in der Praxis",
    "how.desc": "Wir haben den ganzen Ärger beim Autoverkauf beseitigt. Der gesamte Prozess ist rationalisiert, sicher und transparent.",
    "how.step1_title": "Daten übermitteln",
    "how.step1_desc": "Füllen Sie unser intelligentes Formular in weniger als 2 Minuten mit den Fahrzeugdaten und Fotos aus.",
    "how.step2_title": "Wir bewerten das Auto",
    "how.step2_desc": "Unsere Experten analysieren den Markt und machen Ihnen innerhalb von 24 Stunden ein konkretes, unverbindliches Angebot.",
    "how.step3_title": "Wir erledigen Papierkram",
    "how.step3_desc": "Wir erledigen den gesamten administrativen Papierkram und sorgen für eine sichere und schnelle Abwicklung.",
    "how.step4_title": "Schnelle Abholung",
    "how.step4_desc": "Wir holen das Auto an Ihrer Adresse oder Ihrem Arbeitsplatz in ganz Dänemark ab – völlig kostenlos.",

    // Benefits
    "benefits.title": "Wir sind Spezialisten für Autoverkauf und Export",
    "benefits.desc": "Die meisten klassischen Autohändler konzentrieren sich nur auf den dänischen Markt. Wir konzentrieren uns darauf, Ihr spezifisches Problem zu lösen: Wie verkaufen Sie Ihr Auto einfach, schnell und zum besten Preis über den Export?",
    "benefits.bullet1": "Besondere Expertise in Exportmärkten",
    "benefits.bullet2": "Fast 20 Jahre Erfahrung in der Automobilbranche",
    "benefits.bullet3": "Sichere Zahlung per Banküberweisung",
    "benefits.more": "Mehr Vorteile anzeigen",
    "benefits.less": "Weniger Vorteile anzeigen",
    "benefits.b1_title": "Schnelle Bewertung",
    "benefits.b1_desc": "Sie erhalten an Werktagen innerhalb von 24 Stunden ein konkretes und unverbindliches Kaufangebot.",
    "benefits.b2_title": "Keine versteckten Gebühren",
    "benefits.b2_desc": "Die Nutzung unseres Service ist zu 100 % kostenlos. Keine Verwaltungsgebühren oder Überraschungen.",
    "benefits.b3_title": "Bundesweite Abholung",
    "benefits.b3_desc": "Egal wo sich Ihr Auto in Dänemark befindet, wir holen es kostenlos an Ihrer Adresse ab.",
    "benefits.b4_title": "Expertise im Export",
    "benefits.b4_desc": "Wir verfügen über besondere Expertise in den Exportmärkten, was Ihnen den absolut besten Preis sichert.",
    "benefits.b5_title": "Sichere Bezahlung",
    "benefits.b5_desc": "Wir überweisen das Geld sicher per Banküberweisung in voller Übereinstimmung mit der Geldwäschegesetzgebung.",
    "benefits.b6_title": "Persönliche Beratung",
    "benefits.b6_desc": "Unsere Experten beraten Sie während des gesamten Prozesses, sodass Sie sich rundum sicher fühlen.",
    "benefits.b7_title": "Sichere Übergabe",
    "benefits.b7_desc": "Wir unterzeichnen vor der Übergabe des Fahrzeugs digital einen rechtsverbindlichen Kaufvertrag mit MitID.",
    "benefits.b8_title": "Professionelle Aufbereitung",
    "benefits.b8_desc": "Wir übernehmen das Auto so wie es ist und sorgen für eine professionelle Aufbereitung und Inspektion.",

    // Reviews Section
    "reviews.title": "Was unsere Kunden sagen",
    "reviews.desc": "Wir legen großen Wert auf Transparenz, Sicherheit und persönlichen Service. Hier ist eine Auswahl der Erfahrungen unserer Kunden.",
    "reviews.prev": "Zurück",
    "reviews.next": "Weiter",

    // Step Form
    "form.title": "Holen Sie sich eine kostenlose, unverbindliche Marktbewertung",
    "form.desc": "Füllen Sie das folgende Formular aus. Es dauert weniger als 2 Minuten und Sie erhalten innerhalb von 24 Stunden eine Antwort.",
    "form.step": "Schritt",
    "form.of": "von",
    "form.next": "Nächster Schritt",
    "form.prev": "Vorheriger Schritt",
    "form.submit": "Anfrage absenden",
    "form.submitting": "Wird gesendet...",
    "form.success_title": "Vielen Dank für Ihre Anfrage!",
    "form.success_desc": "Wir haben Ihre Informationen erhalten und werden Ihr Auto nun bewerten. Sie erhalten an Werktagen innerhalb von 24 Stunden ein unverbindliches Angebot.",
    "form.success_id": "Ihre Referenznummer lautet:",
    "form.error_title": "Ein Fehler ist aufgetreten",
    "form.error_desc": "Beim Absenden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt.",
    "form.try_again": "Erneut versuchen",

    // Step Form Fields
    "form.step1_title": "Ihr Auto",
    "form.step1_desc": "Geben Sie die Basisdaten Ihres Autos ein",
    "form.license_plate": "Kennzeichen (optional)",
    "form.license_plate_placeholder": "Z.B. AB12345",
    "form.brand": "Marke",
    "form.brand_placeholder": "Z.B. Audi, BMW, Tesla",
    "form.model": "Modell & Variante",
    "form.model_placeholder": "Z.B. A4 Avant 2.0 TDI, i4 M50",

    "form.step2_title": "Leasing & Finanzierung",
    "form.step2_desc": "Informationen zum aktuellen Vertrag",
    "form.leasing_provider": "Leasinggesellschaft / Anbieter",
    "form.leasing_provider_placeholder": "Z.B. ALD, LeasePlan, Jyske Finans",
    "form.residual_value": "Restwert exkl. Steuer & MwSt. (DKK)",
    "form.residual_value_placeholder": "Z.B. 150000",
    "form.expiry_date": "Ablaufdatum des Leasingvertrags",

    "form.step3_title": "Fahrzeugzustand",
    "form.step3_desc": "Erzählen Sie uns vom aktuellen Zustand des Autos",
    "form.mileage": "Kilometerstand (km)",
    "form.mileage_placeholder": "Z.B. 85000",
    "form.damages": "Schäden / Mängel",
    "form.damages_none": "Keine Schäden (normale Gebrauchsspuren)",
    "form.damages_minor": "Leichte Schäden (z. B. Steinschlag, kleine Kratzer)",
    "form.damages_major": "Größere Schäden (z. B. Dellen, Defekte)",
    "form.service_history": "Scheckheft",
    "form.service_full": "Ja, lückenloses Scheckheft",
    "form.service_partial": "Teilweise gepflegt",
    "form.service_none": "Nein, kein Scheckheft",

    "form.step4_title": "Fotos hochladen",
    "form.step4_desc": "Laden Sie bis zu 5 Fotos des Autos hoch (z. B. Front, Heck, Innenraum, Restwertdokument)",
    "form.upload_drag": "Ziehen Sie Ihre Fotos hierher oder",
    "form.upload_browse": "Dateien durchsuchen",
    "form.upload_limits": "Max. 5 Dateien. PDF, PNG, JPEG, GIF, WEBP. Max. 10MB pro Datei (Max. 20MB insgesamt).",
    "form.upload_count": "Fotos ausgewählt",

    "form.step5_title": "Kontakt",
    "form.step5_desc": "Wohin sollen wir Ihr Angebot senden?",
    "form.name": "Vollständiger Name",
    "form.name_placeholder": "Z.B. Max Mustermann",
    "form.phone": "Telefonnummer",
    "form.phone_placeholder": "Z.B. 12345678",
    "form.email": "E-Mail-Adresse",
    "form.email_placeholder": "Z.B. max@mail.com",

    // Footer
    "footer.desc": "Ihr professioneller Partner für den Ankauf und Export von Leasingfahrzeugen. Wir garantieren eine schnelle, sichere und transparente Abwicklung.",
    "footer.nav_title": "Navigation",
    "footer.contact_title": "Kontakt",
    "footer.rights": "Alle Rechte vorbehalten.",
    "footer.privacy": "Datenschutzerklärung",
    "footer.terms": "Allgemeine Geschäftsbedingungen",

    // Contact Page
    "contact.title": "Kontaktieren Sie uns",
    "contact.desc": "Haben Sie Fragen zum Autoverkauf oder wünschen Sie eine persönliche Beratung? Unsere Experten stehen Ihnen gerne zur Verfügung.",
    "contact.direct": "Direkter Kontakt",
    "contact.email_desc": "Wir beantworten alle E-Mails schnell während der Geschäftszeiten.",
    "contact.phone_desc": "Rufen Sie uns für ein unverbindliches Gespräch an.",
    "contact.address_desc": "Besuchen Sie uns nach vorheriger Terminvereinbarung.",
    "contact.hours": "Öffnungszeiten",
    "contact.hours_mon_thu": "Montag - Donnerstag",
    "contact.hours_fri": "Freitag",
    "contact.hours_weekdays": "Montag - Freitag",
    "contact.hours_weekend": "Samstag - Sonntag",
    "contact.hours_weekend_val": "Nach Vereinbarung",
    "contact.hours_weekend_desc": "Geschlossen",
    "contact.badge_title": "Sichere und professionelle Abwicklung",
    "contact.badge_desc": "Wir verfügen über fast 20 Jahre Erfahrung in der Automobilbranche und garantieren einen absolut transparenten Prozess, bei dem die Zahlung sicher per Banküberweisung erfolgt.",
    "contact.form_title": "Senden Sie uns eine Nachricht",
    "contact.form_desc": "Füllen Sie das folgende Formular aus und wir werden uns so schnell wie möglich bei Ihnen melden.",
    "contact.form_success_title": "Vielen Dank für Ihre Nachricht!",
    "contact.form_success_desc": "Wir haben Ihre Anfrage erhalten und werden uns so schnell wie möglich bei Ihnen melden – in der Regel innerhalb von 2 Stunden während unserer Öffnungszeiten.",
    "contact.form_ref_id": "Referenz-ID:",
    "contact.form_new_message": "Eine neue Nachricht senden",
    "contact.form_name": "Name *",
    "contact.form_name_placeholder": "Ihr vollständiger Name",
    "contact.form_phone": "Telefonnummer",
    "contact.form_phone_placeholder": "z.B. +45 12 34 56 78",
    "contact.form_email": "E-Mail-Adresse *",
    "contact.form_email_placeholder": "ihre@email.de",
    "contact.form_subject_label": "Worum geht es?",
    "contact.form_subject": "Betreff",
    "contact.form_subject_placeholder": "Betreff auswählen",
    "contact.form_subject_opt1": "Verkauf eines Leasingfahrzeugs",
    "contact.form_subject_opt2": "Export eines Fahrzeugs",
    "contact.form_subject_opt3": "Allgemeine Anfrage",
    "contact.form_subject_opt4": "Sonstiges",
    "contact.form_subject_opt5": "Fragen zur Bewertung",
    "contact.form_message": "Nachricht *",
    "contact.form_message_placeholder": "Schreiben Sie Ihre Nachricht hier...",
    "contact.form_upload_label": "Dokumente oder Bilder anhängen (optional)",
    "contact.form_upload_desc": "z.B. Zulassungsbescheinigung oder Bilder des Autos. Max. 5 Dateien, max. 10 MB pro Datei (PDF, PNG, JPEG, GIF, WEBP).",
    "contact.form_upload_click": "Klicken Sie hier, um Dateien auszuwählen",
    "contact.form_upload_drag": "oder hierher ziehen",
    "contact.form_upload_selected": "Ausgewählte Dateien",
    "contact.form_submitting": "Nachricht wird gesendet...",
    "contact.form_submit": "Nachricht senden",
    "contact.form_success": "Vielen Dank für Ihre Nachricht! Wir werden uns so schnell wie möglich bei Ihnen melden.",
    "contact.form_error": "Beim Absenden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",

    // Export Cars Page
    "export.title": "Vejle Auto Export – Ihr vertrauenswürdiger Partner für Exportfahrzeuge",
    "export.desc": "Vejle Auto Export ist ein angesehener Autohändler mit Sitz in Dänemark, der sich auf den Kauf und Verkauf von Qualitätsfahrzeugen für den Export spezialisiert hat. Mit über 19 Jahren Erfahrung haben wir uns als vertrauenswürdige Quelle für Gebrauchtfahrzeuge aller Klassen etabliert.",
    "export.p2": "Unsere Auswahl wird sorgfältig zusammengestellt, um sicherzustellen, dass unseren Kunden nur qualitativ hochwertige Autos angeboten werden. Wir sind bestrebt, in jeder Phase des Kaufprozesses einen hervorragenden Service und fachkundige Beratung zu bieten.",
    "export.p3": "Wenn Sie ein Experte in der Automobilbranche sind, laden wir Sie ein, uns zu kontaktieren oder unseren Standort zu besuchen, um unsere Auswahl zu erkunden und zu entdecken, was uns auszeichnet. Wir sind zuversichtlich, dass unsere Erfahrung und unser Engagement für Spitzenleistungen Ihre Erwartungen übertreffen werden.",
    "export.cta_explore": "Erkunden Sie noch heute unser Angebot an Exportfahrzeugen!",
    "export.cta_sale": "Exportfahrzeuge zum Verkauf",
    "export.cta_mobile": "Besuchen Sie Mobile.de",
    "export.experience_badge": "19+ Jahre Erfahrung",
    "export.experience_badge_desc": "Etabliert als vertrauenswürdige Quelle für Gebrauchtfahrzeuge aller Klassen.",
    "export.sec2_title": "Renommierter Autohändler",
    "export.sec2_desc": "Vejle AutoExport ist ein renommierter Autohändler, der seit über einem Jahrzehnt Kunden in Dänemark bedient. Wir sind darauf spezialisiert, qualitativ hochwertige Gebrauchtwagen verschiedener Modelle der Baujahre 2012 bis 2022 anzubieten.",
    "export.sec2_p1": "Unser Bestand umfasst eine breite Palette von Fahrzeugen verschiedener Klassen, von Aygo bis McLaren, alle ausgestattet mit fortschrittlichen Fahrtechnologien.",
    "export.sec2_p2": "Unser Autohaus bietet die neuesten Fahrfunktionen, darunter fortschrittliche Fahrerassistenzsysteme, Einparkhilfe, adaptiven Tempomaten, Spurhalteassistenten und vieles mehr.",
    "export.sec2_p3": "Wir bieten unseren Kunden erstklassigen Kundenservice, um ihnen bei der Auswahl des Autos zu helfen, das ihren Bedürfnissen am besten entspricht.",
    "export.sec2_p4": "Wir sind bestrebt, eine große Auswahl an Fahrzeugen in unserem Bestand zu halten, weshalb wir unsere Kollektion kontinuierlich mit den neuesten Modellen aktualisieren. Unser Ziel ist es, unseren Kunden eine breite Palette an Optionen zu bieten, um sicherzustellen, dass sie das Auto finden, das perfekt zu ihren Anforderungen passt.",
    "export.sec3_title": "KONTAKT",
    "export.sec3_desc": "Haben Sie Fragen oder wünschen Sie ein unverbindliches Angebot für Ihr Auto? Kontaktieren Sie uns noch heute für ein schnelles und professionelles Gespräch.",
    "export.sec3_cta_contact": "Zum Kontaktformular",
    "export.sec3_cta_valuation": "Kostenlose Bewertung erhalten",

    "export.reviews_title": "Unsere Kundenbewertungen",
    "export.reviews_desc": "Wir sind stolz auf unsere hohe Kundenzufriedenheit sowohl auf Google als auch auf Mobile.de. Sehen Sie sich unsere Bewertungen direkt hier an.",
    "export.google_rating": "Hervorragend auf Google",
    "export.google_rating_desc": "Basierend auf 69 Bewertungen",
    "export.google_cta": "Bewertungen auf Google ansehen",
    "export.mobile_rating": "Hervorragend auf Mobile.de",
    "export.mobile_rating_desc": "Basierend auf unseren neuesten Bewertungen",
    "export.mobile_cta": "Bewertungen auf Mobile.de ansehen",

    "export.terms_title": "B2B Exportbedingungen & Verkaufsbedingungen",
    "export.terms_subtitle": "Bitte lesen Sie unsere offiziellen Geschäftsbedingungen für den gewerblichen B2B-Export, Zahlungen und Dokumentation.",
    "export.terms_b2b_title": "B2B Exportbedingungen",
    "export.terms_b2b_text": "Verkauf als B2B-Exportfahrzeug im aktuellen Zustand ohne Gewährleistung. Nur für den Export. Keine Reklamationen oder Rückgaben nach dem Kauf. Zwischenverkauf und Irrtümer vorbehalten.",
    "export.terms_payment_title": "Zahlung & Reservierung",
    "export.terms_payment_b1": "Keine ⛔ €500-Banknoten akzeptiert. Maximale Barzahlung: €2.000.",
    "export.terms_payment_b2": "Reservierung: Eine Anzahlung von 10% ist innerhalb von 2 Werktagen erforderlich, mindestens jedoch €500. Das Auto wird erst nach Erhalt der Anzahlung reserviert.",
    "export.terms_eu_title": "EU-Gewerbehändler",
    "export.terms_eu_subtitle": "Netto oder Brutto erforderlich:",
    "export.terms_eu_b1": "1. Gewerbeanmeldung / Handelsregisterauszug",
    "export.terms_eu_b2": "2. USt-IdNr. und Ausweis des Inhabers erforderlich",
    "export.terms_eu_b3": "✅ Eine VIES-Prüfung wird vor dem Verkauf durchgeführt.",
    "export.terms_noneu_title": "Nicht-EU-Export",
    "export.terms_noneu_b1": "25% MwSt.-Kaution + €53 MRN-Zollgebühr vor Freigabe erforderlich.",
    "export.terms_noneu_b2": "Die MwSt. wird erstattet, sobald ein gültiger Nachweis des MRN Follow-up (Export & Transit) der Europäischen Kommission vorliegt.",
    "export.terms_netto_title": "Dokumentation für Netto-Fahrzeuge",
    "export.terms_netto_b1": "Für die MwSt.-Rechnung ist der Verkauf in Netto erforderlich.",
    "export.terms_netto_b2": "Für innergemeinschaftliche Lieferungen in der EU: Wenn bei Ankunft des Fahrzeugs kein CMR-Dokument vorliegt, wird eine Gelangensbestätigung (DE-Gelangensbestätigung) als Nachweis der EU-Lieferung bereitgestellt.",
    "export.terms_brutto_title": "Dokumentation für Brutto-Fahrzeuge",
    "export.terms_brutto_b1": "Video der Verladung inklusive Adresse und Fahrgestellnummer (VIN) oder unterschriebener CMR erforderlich.",
    "export.terms_plates_title": "Exportkennzeichen & Versicherung",
    "export.terms_plates_b1": "Bestellung 1 Tag im Voraus.",
    "export.terms_plates_b2": "€30 pro Tag inkl. Haftpflichtversicherung, maximal 7 Tage.",

    // Our History Page
    "history.title": "Wer ist Vejle Auto Export?",
    "history.desc": "Wir sind ein mittleres bis großes Unternehmen mit Sitz im Süden Dänemarks, das sich auf den bundesweiten Ankauf von Gebrauchtwagen spezialisiert hat.",
    "history.p2": "Seit 2007 konzentriert sich Vejle AutoExport auf den professionellen Handel mit Gebrauchtfahrzeugen – sowohl von privaten als auch von professionellen Partnern.",
    "history.p3": "Unser Geschäft basiert auf langjähriger Erfahrung, Effizienz und Zuverlässigkeit durch Akquisitionen aus folgenden Segmenten:",
    "history.segment_b2b": "B2B (Business-to-Business)",
    "history.segment_b2c": "B2C (Business-to-Consumer)",
    "history.segment_leasing": "Leasinggesellschaften",
    "history.segment_auctions": "Auktionen",
    "history.segment_banks": "Banken",
    "history.p4": "Wir bieten flexible Lösungen und reibungslose Transaktionen, egal ob Sie ein Unternehmen, eine Leasinggesellschaft, eine Bank oder eine Privatperson vertreten. Unser guter Ruf und unser breites Netzwerk in der Branche machen uns zu einem bevorzugten Partner beim Handel mit Gebrauchtfahrzeugen.",
    "history.read_also": "LESEN SIE AUCH ÜBER",
    "history.read_sell": "Verkaufen Sie Ihr Auto",
    "history.read_export": "Export Cars For Sale",
    "history.sec2_title": "Was habe ich davon, mein Auto an Vejle Auto Export zu verkaufen?",
    "history.val1_title": "Know-how & Großes Netzwerk:",
    "history.val1_desc": "Wir haben ein starkes Netzwerk von über +3.000 ausländischen Händlern aufgebaut, das den besten Preis für Ihr Auto garantiert.",
    "history.val2_title": "Schneller und einfacher Prozess:",
    "history.val2_desc": "Verkaufen Sie Ihr Auto ohne Aufwand – wir kümmern uns um alles, sodass Sie kaum einen Finger rühren müssen.",
    "history.val3_title": "100% Transparenter Deal:",
    "history.val3_desc": "Bei uns ist der gesamte Prozess transparent, sodass Sie ihn von Anfang bis Ende sicher mitverfolgen können.",
    "history.val4_title": "Mehr als +19 Jahre Erfahrung:",
    "history.val4_desc": "Wir verfügen über solide Branchenerfahrung und bieten professionellen Service, dem Sie vertrauen können.",
    "history.sec3_title": "- KONTAKT -",
    "history.sec3_desc": "Haben Sie Fragen oder wünschen Sie ein unverbindliches Angebot für Ihr Auto? Kontaktieren Sie uns noch heute für ein schnelles und professionelles Gespräch.",
    "history.sec3_cta_form": "Zum Kontaktformular",
    "history.sec3_cta_val": "Kostenlose Bewertung erhalten",

    // Sell Leasing Car Page
    "sell.title": "Verkaufen Sie Ihr Leasingfahrzeug ohne Steuer und MwSt.",
    "sell.desc": "Haben Sie ein Leasingfahrzeug, das abgewickelt werden muss? Wir sind Spezialisten für den Direktankauf und Export von Leasingfahrzeugen. Wir lösen den Restwert direkt bei Ihrer Leasinggesellschaft ab und sorgen dafür, dass Sie den absolut besten Marktpreis erhalten.",
    "sell.cta_form": "Berechnen Sie jetzt den Wert Ihres Autos",
    "sell.cta_how": "Sehen Sie, wie es funktioniert",
    "sell.faq_title": "Häufig gestellte Fragen zum Verkauf eines Leasingfahrzeugs",
    "sell.faq_desc": "Hier finden Sie Antworten auf die häufigsten Fragen, wie wir Ihnen helfen, Ihr Leasingfahrzeug schnell, sicher und zum besten Preis abzuwickeln.",
    "sell.reviews_title": "Was unsere Kunden über den Verkauf von Leasingfahrzeugen sagen",
    "sell.reviews_desc": "Lesen Sie Bewertungen von Kunden, die ihr Leasing- oder Exportfahrzeug über uns verkauft haben.",
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    const saved = localStorage.getItem('lease_retur_lang');
    if (saved && ['da', 'en', 'de'].includes(saved)) {
      return saved;
    }
    return 'da';
  });

  const setLanguage = (lang) => {
    if (['da', 'en', 'de'].includes(lang)) {
      setLanguageState(lang);
      localStorage.setItem('lease_retur_lang', lang);
      // Update HTML lang attribute
      document.documentElement.setAttribute('lang', lang);
    }
  };

  useEffect(() => {
    document.documentElement.setAttribute('lang', language);
  }, [language]);

  const t = (key) => {
    if (translations[language] && translations[language][key]) {
      return translations[language][key];
    }
    // Fallback to Danish
    if (translations.da && translations.da[key]) {
      return translations.da[key];
    }
    return key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
